
class ScrollSpyFixableTarget{
    constructor(node){
        this.node = node
        this.is_fixed = false
        this.fix_placeholder_node = null

        // this.onResize()
        const rect = this.node.getBoundingClientRect()
        this.ensurePlaceholder(rect)
        this.fixElement(rect)
    }
    onScroll(){
        if(! this.is_fixed){
            const rect = this.node.getBoundingClientRect()
            if(rect.top <= 0 && !this.is_fixed){
                this.ensurePlaceholder(rect)
                this.fixElement(rect)
                this.is_fixed = true
            }    
        }else{
            const rect = this.fix_placeholder_node.getBoundingClientRect()
            if(rect.top > 0  && this.is_fixed){
                this.hidePlaceholder()
                this.unfixElement()
                this.is_fixed = false
            }
        }
    }
    onResize(){
        this.is_fixed = false
        this.ensurePlaceholder(this.node.getBoundingClientRect())
        this.hidePlaceholder()
        this.unfixElement()
        this.onScroll()
    }
    ensurePlaceholder(rect){
        if(! this.fix_placeholder_node){
            this.fix_placeholder_node = document.createElement('div');
            this.fix_placeholder_node.id = 'fix_placeholder'
            this.node.parentElement.insertBefore(this.fix_placeholder_node, this.node)
        }
        this.fix_placeholder_node.style.height = `${rect.height}px`
        this.fix_placeholder_node.style.width = `${rect.width}px`
        this.fix_placeholder_node.style.display = 'block'
    }
    hidePlaceholder(element){
        if(this.fix_placeholder_node){
            this.fix_placeholder_node.style.display = 'none'
        }
    }
    fixElement(rect){
        // this.node.style.width = `100vw`
        // this.node.style.width = `${window.innerWidth}px`

        const width = document.body.getBoundingClientRect().width;
        // console.log(width)

        // this.node.style.width = `${window.innerWidth}px`
        // this.node.style.width = `${rect.width}px`
        this.node.style.width = `${width}px`
        this.node.style.position = 'fixed'
        this.node.style.left = `${rect.left}px`
        this.node.style.top = `${0}px`
        this.node.style.zIndex = 999
        this.node.classList.add('is--fixed')
    }
    unfixElement(){
        this.node.setAttribute('style', '')
        this.node.classList.remove('is--fixed')
    }
}

export {
    ScrollSpyFixableTarget
}